import React from 'react';
import { Footer } from '@vwfs-bronson/bronson-react';

const footerLinks = [
  { name: 'Legal Notice', url: 'https://customer.vwfs.co.uk/legal-notice.html' },
  { name: 'Privacy Policy ', url: 'https://customer.vwfs.co.uk/privacy-policy.html' },
  { name: 'Cookies Policy', url: 'https://customer.vwfs.co.uk/cookies-policy.html' },
  { name: 'Modern Slavery Statement ', url: 'https://customer.vwfs.co.uk/modern-slavery-statement.html' },
  { name: '3rd Party Licences', url: 'https://myvwfinance.vwfs.co.uk/third-party-licences' },
  { name: 'Have a Complaint?', url: 'https://customer.vwfs.co.uk/customer-concern-policy.html' }
];

export const AppFooter: React.FC = () => {
  return (
    <>
      <Footer>
        <Footer.ModuleMetaNav copyrightText="" copyrightSign="">
          {footerLinks.map(link => (
            <Footer.ModuleMetaNav.Item key={link.url} href={link.url} linkProps={{ target: '_blank' }}>
              {link.name}
            </Footer.ModuleMetaNav.Item>
          ))}
        </Footer.ModuleMetaNav>
      </Footer>
    </>
  );
};
